<template>
    <div id="support">
<!--      <navbar :data="0" />-->
      <div class="content" style="padding: 160px 0 0 0" >
        <div  class="social-nav filter-blur-50 border-bottom-white-1-50">
          <div class="nameContainer" style="width: 25vw">
            <router-link to="/personal" class="d-flex">
              <div class="homeIcon">
                <a><img src="../../assets/icons/homeIcon.svg" height="20px" width="20px"></a>
              </div>
            </router-link>
            <div class="arrowIcon">
              <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">
            </div>
            <div class="titleName">{{$t('Support.title')}}</div>
          </div>
          <div style="width: 75vw" class="tabsContainer">
            <v-tabs
              v-model="tab"
              grow
              centered
              show-arrows
              class="social-tab"
            >
              <v-tabs-slider color="#FFCB05" ></v-tabs-slider>
              <v-tab v-for="(item, i) in support.items" :key="item.title">
                <span :class="[(lang === 'ar' && i !== tab ? 'regular-ar' : i !== tab ? 'regular-en' : lang === 'ar' && i === tab ? 'bold-ar' : 'bold-en')]">{{ item.title }}</span>
<!--                {{ item.title }}-->
              </v-tab>
            </v-tabs>
          </div>
        </div>
        <div>
        <v-tabs-items v-model="tab" :touchless="true">
          <v-tab-item v-for="item in support.items" :key="item.title">
            <component :is="item.comp" />
          </v-tab-item>
        </v-tabs-items>
        </div>
      </div>
<!--      <Footer />-->
    </div>
</template>

<script>
// import Navbar from '../Navbar'
// import Footer from '../../components/core/Footer'
import ContactUs from './ContactUs'
import FAQs from './FAQs'
import Feedback from './Feedback'
import ServicesCenters from './ServicesCenters'
import utils from '../../shared/utils'
import $ from 'jquery'
export default {
  name: 'support',
  components: { ContactUs, FAQs, Feedback, ServicesCenters },
  data () {
    return {
      tab: null,
      lang: this.$lang,
      support: {
        title: 'Support',
        items: [
          {
            title: this.$t('supportMenu.faq'),
            comp: 'FAQs',
            path: 'FAQs'
          },
          {
            title: this.$t('supportMenu.serviceCenter'),
            comp: 'ServicesCenters',
            path: 'Services-Centers'
          },
          {
            title: this.$t('supportMenu.feedback'),
            comp: 'Feedback',
            path: 'Feedback'
          },
          {
            title: this.$t('supportMenu.contactUs'),
            comp: 'ContactUs',
            path: 'Contact-Us'
          }]
      }
    }
  },
  watch: {
    tab (val) {
      window.scrollTo(0, 0)
      if (val === 1) {
        this.$lang === 'ar' ? $('svg.w-6.h-6.vue-simple-select-icon').css({ 'margin-left': 0, 'margin-right': 'auto' }) : $('svg.w-6.h-6.vue-simple-select-icon').css({ 'margin-left': 'auto', 'margin-right': 0 })
      }
      this.$store.state.supportSectionTabs = val
    },
    '$route.params.id': {
      handler: function (id) {
        this.tab = utils.checkActiveTab(this.support.items, id)
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.arabic()
    this.activeTab = this.$route.params.id
    this.$store.state.activeSectionNav = null
  },
  mounted () {
    this.tab = utils.checkActiveTab(this.support.items, this.activeTab)
    this.arabic()
  },
  methods: {
    arabic () {
      if (this.$lang === 'ar') {
        $('.social-nav').css('direction', 'rtl')
        $('.arrowIcon').css('transform', 'rotateY(180deg)')
        $('.tabsContainer').addClass('arabicTabContainer')
        $('.social-tab .v-tab').css('transform', 'rotateY(180deg)')
        // $('.social-tab .v-tab--active').css('font-family', 'Mtn-arabic-bold !important')
        $('.social-tab .v-tab--active').addClass('arabicBold')
        $('.social-tab .v-tab').css('font-family', 'Mtn-arabic-regular')
        $('#support .social-nav .v-tabs').addClass('arabicP')
      } else {
        $('.social-tab .v-tab--active').removeData('arabicBold')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/main";
@import "src/assets/sass/modules/tabs";
.content{
  min-height: calc(100vh - (170px + 285.6px)) !important;
}
  .tabsContainer {
    height: 60px;
  }
  .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
    color: rgba(29, 29, 29, 0.6) !important;
  }
  .social-tab .v-tab--active {
    color: $--yellow !important;
  }
  .social-tab .v-tab--active {
    color: $--yellow !important;
    font-family: Mtn-bold ;
    font-size: 12px;
    font-style: normal !important;
  }
  /*.social-tab .v-slide-group__wrapper{*/
  /*  box-shadow: 10px 10px 30px 0px rgba(0, 0, 0, 0.1) !important;*/
  /*}*/

  .social-nav{
  //background: rgba(212, 212, 212, 0.45);
  //background-color: $--light-white;
    height: 50px;
  //box-shadow: 10px 10px 30px 0px rgba(0, 0, 0, 0.1) !important;
    background: rgba(242, 242, 242, 1) !important;
    box-shadow: 0 15px 25px rgba(0, 0, 0, 0.1);
  //backdrop-filter: blur(40px);
    margin: 0px 0px;
    display: flex;
    position: fixed;
    z-index: 10;
    z-index: 210;
    top: 110px;
  }
  .social-nav .v-tabs, .v-tabs-bar {
    height: 100% !important;
  }
  .theme--light.v-tabs > .v-tabs-bar {
    background: transparent!important;
  }
  .social-nav .v-tabs{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 50px !important;
  }
  .nameContainer{
    display: flex;
    padding: 0 4vw 0 5vw;
  }
  .homeIcon {
    cursor: pointer;
  }
  .homeIcon,
  .arrowIcon,
  .titleName{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1vw;
  }
  .titleName{
    width: max-content;
    color: $--yellow;
    font-family: Mtn-bold;
    text-decoration: underline;
  }
  .social-tab .v-tab{
    padding: 0 4vw;
    font-size: 10px;
  }
 #support .social-nav .v-tabs{
  padding: 0 4vw !important;
}
  @media only screen and (max-width: 750px) {
    .homeIcon,
    .arrowIcon,
    .nameContainer{
      display: none;
    }
    .tabsContainer{
      width: 100vw !important;
    }
    .social-nav .v-tabs{
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .arabicTabContainer{
    direction: ltr;
    transform: rotateY(180deg);
  }
  .arabicBold{
    font-family: Mtn-arabic-bold !important;
  }
</style>
<style>
  .theme--light.v-tabs > .v-tabs-bar{
    background-color: transparent !important;
  }
  #support .social-nav .v-tabs .arabicP{
    padding: 0 1vw 0 3vw !important;
  }
  #support .v-item-group.theme--light.v-slide-group.v-tabs-bar.v-tabs-bar--is-mobile.v-tabs-bar--show-arrows.primary--text, .v-item-group.theme--light.v-slide-group.v-tabs-bar.v-tabs-bar--show-arrows.primary--text {
    height: 50px !important;
  }
  #support .v-slide-group__wrapper{
    height: 50px !important;
  }
  /*#support .social-nav .v-slide-group__prev, #support .social-nav .v-slide-group__next {*/
  /*  display: none !important;*/
  /*}*/
  /*@media only screen and (max-width: 490px) {*/
  /*  #support .social-nav .v-slide-group__prev, #support .social-nav .v-slide-group__next {*/
  /*    display: flex !important;*/
  /*  }*/
  /*}*/
</style>
